export default [
  {
    path: '/system',
    name: 'system',
    component: () =>
      import(/* webpackChunkName: "system" */ '@/views/System.vue')
  },
  {
    path: '/system/history-companies',
    name: 'admin-history-companies',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/components/admin/history_companies/HistoryCompanies.vue')
  },
  {
    path: '/system/skills',
    name: 'admin-skills',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/components/admin/skills/Skills.vue')
  },
  {
    path: '/system/education-institutions',
    name: 'admin-education-institutions',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/components/admin/education_institutions/EducationInstitutions.vue')
  },
  {
    path: '/system/education-degrees',
    name: 'admin-education-degrees',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/components/admin/education_degrees/EducationDegrees.vue')
  },
  {
    path: '/system/education-courses',
    name: 'admin-education-courses',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/components/admin/education_courses/EducationCourses.vue')
  },
  {
    path: '/system/job-titles',
    name: 'admin-job-titles',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/components/admin/job_titles/JobTitles.vue')
  },
  {
    path: '/system/filters',
    name: 'admin-filters',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/components/admin/filters/Filters.vue')
  },
  {
    path: '/system/key-words',
    name: 'system-key-words',
    component: () =>
      import(/* webpackChunkName: "system" */ '@/views/system/KeyWords.vue')
  },
  {
    path: '/system/admin-requirments',
    name: 'system-admin-requirments',
    component: () =>
      import(/* webpackChunkName: "system" */ '@/views/system/AdminRequirments.vue')
  },
  {
    path: '/system/job-title-skills',
    name: 'job-title-skills',
    component: () =>
      import(/* webpackChunkName: "system" */ '@/views/system/JobTitleSkills.vue')
  },
  {
    path: '/system/qr-code-generator',
    name: 'qr-code-generator',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/views/admin/GenerateQRCode.vue')
  },
  {
    path: '/system/offer-statuses',
    name: 'offer-statuses',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/views/admin/OfferStatuses.vue')
  },
  {
    path: '/system/settings',
    name: 'settings',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/views/admin/Settings.vue')
  },
  {
    path: '/system/admins',
    name: 'admin-list',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/views/admin/AdminList.vue')
  },
  {
    path: '/system/huji',
    name: 'admin-huji',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/components/admin/huji/Huji.vue')
  },
  {
    path: '/system/languages',
    name: 'admin-languages',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/components/admin/languages/Languages.vue')
  },
  {
    path: '/system/tag-list',
    name: 'tag-list',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/views/admin/TagList.vue')
  },
  {
    path: '/system/blog',
    name: 'admin-blog',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/components/admin/blog/Blog.vue')
  },
  {
    path: '/system/position-recommendations',
    name: 'position-recommendations',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/views/system/PositionRecommendations.vue')
  },
  {
    path: '/system/chatbot-conversations',
    name: 'chatbot-conversations',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/views/system/ChatbotConversations.vue')
  },
  {
    path: '/system/vector-match-test',
    name: 'vector-match-test',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/views/system/VectorMatchTest.vue')
  },
  {
    path: '/recruiter-qa/all',
    name: 'admin-recruiter-qa',
    component: () =>
        import(/* webpackChunkName: "system" */ '@/views/system/RecruiterQaAdmin.vue')
  }
]
